import { Component, Input } from '@angular/core';
import { ProcessingData } from 'src/app/components/shared/types/processingData.type';

@Component({
  selector: 'app-mu-loading-modal-dialog',
  templateUrl: './mu-loading-modal-dialog.component.html',
  styleUrls: ['./mu-loading-modal-dialog.component.sass'],
})
export class MuLoadingModalDialogComponent {
  /**
   * Processing Data
   */
  @Input()
  processingData: ProcessingData<any>;

  constructor() {
    /** */
  }

  get dialogTitle() {
    if (this.processingData.errorState) {
      return this.processingData.errorTitle;
    }
    return this.processingData.title;
  }
  /**
   * Called when the modal is closed because of an error
   */
  closeModalByError() {
    this.processingData.end();
  }
}
